/**
 * The class from which all exceptions extend.
 * All errors not extending from this exception will be considered unexpected, uncaught, and unhandled.
 */
export class CoreUiException extends Error {

    originalError?: Error;

    constructor(name?: string, message?: string, originalError?: any) {

        super(message || "An error has occured");
        // Work around for Error Extension
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, CoreUiException.prototype);

        this.name = name || "Exception";
        this.originalError = originalError;

    }
}
